import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Validate Supabase configuration
if (!supabaseUrl || !supabaseAnonKey) {
  if (process.env.NODE_ENV === 'development') {
    console.error('❌ Missing Supabase environment variables!')
  }
}

// Create client even if credentials are missing (for development)
export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey
) 